import React, { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { toast } from "sonner";
import PageHeader from "../components/PageHeader";
import CrudTable from "../components/CrudTable";
import { useAuth } from "../context/AuthContext";
import { damga } from "../lib/stamp";
import { Lightbulb, Plus, Loader2, ChevronDown, ChevronRight, FileSignature, ClipboardCheck, Download, Printer, Columns3, Trash2, Pencil, Filter } from "lucide-react";

const VARDIYA = ["00:00 - 08:00", "08:00 - 16:00", "16:00 - 24:00"];
const BOLUMLER = ["SERVİS", "PASTA", "ÇUKUR", "MAKARNA", "KASE", "PLAKA", "DOLGU"];
const today = () => new Date().toISOString().slice(0, 10);
const trTarih = (s) => {
  if (!s) return "—";
  const p = String(s).slice(0, 10).split("-");
  return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : s;
};

async function printSignedPlan() {
  let rows = [];
  try { rows = (await api.get("/entity/planlama")).data; } catch { return; }
  const groups = {};
  rows.forEach((r) => { const k = `${trTarih(r.tarih)} • ${r.vardiya || "—"}`; (groups[k] = groups[k] || []).push(r); });
  const w = window.open("", "_blank");
  if (!w) { toast.error("Yazdırma penceresi açılamadı (pop-up engelli)"); return; }
  let body = "";
  Object.keys(groups).sort().forEach((k) => {
    const list = groups[k];
    const toplam = list.reduce((s, r) => s + (Number(r.adet) || 0), 0);
    const trs = list.map((r) => `<tr><td>${r.urun_kodu_tam || ""}</td><td>${r.bolum || ""}</td><td>${r.urun_kodu || ""}</td><td>${r.aciklama || ""}</td><td class="r">${(Number(r.adet) || 0).toLocaleString("tr-TR")}</td><td>${r.notu || ""}</td><td>${r.logo || ""}</td></tr>`).join("");
    body += `<h2>${k}</h2><table><thead><tr><th>Ürün Kodu (Tam)</th><th>Bölüm</th><th>Ürün Kodu</th><th>Açıklama</th><th class="r">Adet</th><th>Not</th><th>Logo</th></tr></thead><tbody>${trs}<tr class="tot"><td colspan="4">GENEL TOPLAM</td><td class="r">${toplam.toLocaleString("tr-TR")}</td><td></td><td></td></tr></tbody></table>
      <div class="sign"><div>Hazırlayan<br/><br/>____________________</div><div>Vardiya Amiri<br/><br/>____________________</div><div>Üretim Sorumlusu<br/><br/>____________________</div><div>Onay (Yönetici)<br/><br/>____________________</div></div>`;
  });
  w.document.write(`<!DOCTYPE html><html lang="tr"><head><meta charset="utf-8"><title>Üretim Planlama - ${damga()}</title>
    <style>@page{size:A4;margin:12mm;} *{-webkit-print-color-adjust:exact;} body{font-family:Arial;color:#111;}
    .hdr{display:flex;justify-content:space-between;border-bottom:2px solid #18181B;padding-bottom:6px;margin-bottom:8px;}
    h1{font-size:16px;margin:0;} h2{font-size:12px;background:#18181B;color:#fff;padding:4px 8px;margin:14px 0 0;}
    table{border-collapse:collapse;width:100%;font-size:10px;margin-bottom:6px;} th,td{border:1px solid #333;padding:4px 6px;} th{background:#E9E9E9;} .r{text-align:right;} .tot{font-weight:bold;background:#f0f0f0;}
    .sign{display:flex;justify-content:space-between;font-size:10px;margin:10px 0 24px;text-align:center;} .sign div{width:23%;}
    </style></head><body>
    <div class="hdr"><h1>ÜRETİM PLANLAMA — GÜNLÜK İMZA FORMU</h1><div style="font-size:10px">${new Date().toLocaleString("tr-TR")}</div></div>
    ${body || "<p>Plan kaydı yok.</p>"}</body></html>`);
  w.document.close(); w.focus();
  setTimeout(() => w.print(), 300);
}

const TerminCell = ({ t }) => {
  if (!t) return <span className="text-zinc-300">—</span>;
  const trd = String(t).slice(0, 10).split("-").reverse().join(".");
  const d = new Date(String(t).slice(0, 10) + "T00:00:00");
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const diff = Math.round((d - today) / 86400000);
  if (diff < 0) return <span className="mono inline-block rounded px-2 py-0.5 text-xs font-bold bg-red-100 text-red-700 border border-red-200" title="Termin geçti">{trd}</span>;
  if (diff <= 7) return <span className="mono inline-block rounded px-2 py-0.5 text-xs font-bold bg-amber-100 text-amber-700 border border-amber-200" title="Termin yaklaşıyor">{trd}</span>;
  return <span className="mono text-zinc-700">{trd}</span>;
};

const terminCls = (t) => {
  if (!t) return "";
  const d = new Date(String(t).slice(0, 10) + "T00:00:00");
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const diff = Math.round((d - today) / 86400000);
  if (diff < 0) return "bg-red-100 text-red-700 border border-red-200";
  if (diff <= 7) return "bg-amber-100 text-amber-700 border border-amber-200";
  return "";
};

const terminHex = (t) => {
  if (!t) return null;
  const d = new Date(String(t).slice(0, 10) + "T00:00:00");
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const diff = Math.round((d - today) / 86400000);
  if (diff < 0) return { bg: "#F4CCCC", fg: "#990000" };
  if (diff <= 7) return { bg: "#FCE5CD", fg: "#B45309" };
  return null;
};
const EXCEL_LEGEND = (n) => `<tr><td colspan="${n}" style="background:#fff;font-size:11px;padding:4px;">Renk kodu: <span style="background:#F4CCCC;color:#990000;font-weight:bold;padding:1px 6px;">Termin geçti</span> &nbsp; <span style="background:#FCE5CD;color:#B45309;font-weight:bold;padding:1px 6px;">Termin yaklaşıyor (≤7 gün)</span></td></tr>`;
const PDF_LEGEND = `<div style="font-size:10px;margin-bottom:6px;">Renk kodu: <span style="background:#F4CCCC;color:#990000;font-weight:bold;padding:1px 6px;">Termin geçti</span> &nbsp; <span style="background:#FCE5CD;color:#B45309;font-weight:bold;padding:1px 6px;">Termin yaklaşıyor (≤7 gün)</span></div>`;

const ONERI_COLS = [
  { key: "termin_tarihi", label: "Termin", cls: "mono", render: (s) => <TerminCell t={s.termin_tarihi} /> },
  { key: "musteri", label: "Müşteri" },
  { key: "urun_kodu", label: "Ürün Kodu", cls: "mono", render: (s) => { const c = terminCls(s.termin_tarihi); return <span className={c ? `mono inline-block rounded px-2 py-0.5 text-xs font-bold ${c}` : "mono"}>{s.urun_kodu}</span>; } },
  { key: "kalip_kodu", label: "Kalıp", cls: "mono" },
  { key: "renk", label: "Renk" },
  { key: "bolum", label: "Bölüm" },
  { key: "kalan", label: "Kaliteye Göre Kalan", num: true },
  { key: "uretime_gore_kalan", label: "Üretime Göre Kalan", num: true, cls: "num text-red-600 font-semibold" },
  { key: "uretime_yapilan", label: "Üretime Göre Yapılan", num: true, cls: "num text-blue-700 font-semibold" },
  { key: "kalite_yapilan", label: "Kaliteye Göre Yapılan", num: true, cls: "num text-emerald-700 font-semibold" },
  { key: "kaliteden_gecmemis", label: "Kaliteden Geçmemiş Ürün", num: true, cls: "num text-orange-600 font-semibold" },
  { key: "kaliteden_gecmeyen", label: "Kaliteden Geçmemiş Ürün Üretim Girişi", num: true, cls: "num text-rose-600 font-semibold" },
  { key: "biskuvi_stok", label: "Bisküvi Stok", num: true, cls: "num text-sky-700 font-semibold" },
  { key: "onerilen_adet", label: "Önerilen", num: true, cls: "num text-green-700 font-bold" },
  { key: "plana_yazilan", label: "Plana Yazılan", num: true, cls: "num",
    render: (s) => <PlanaYazilanCell s={s} /> },
];
const vardiyaKisa = (v) => String(v || "").replace(/:00/g, "").replace(/\s+/g, "");
const plDetayTxt = (d) => `${trTarihKisa(d.tarih)} ${vardiyaKisa(d.vardiya)}: ${Number(d.adet).toLocaleString("tr-TR")}`;
const trTarihKisa = (s) => { const p = String(s || "").slice(0, 10).split("-"); return p.length === 3 ? `${p[2]}.${p[1]}` : s; };
const cellVal = (r, c) => (c.key === "plana_yazilan" && (r.plana_yazilan_detay || []).length
  ? `${r.plana_yazilan} (${r.plana_yazilan_detay.map(plDetayTxt).join(", ")})` : r[c.key]);
function PlanaYazilanCell({ s }) {
  if (!(Number(s.plana_yazilan) > 0)) return <span className="text-zinc-300">—</span>;
  return (
    <div className="flex flex-col items-end gap-0.5" data-testid={`plana-yazilan-${s.urun_kodu}`}>
      <span className="text-purple-700 font-bold">{Number(s.plana_yazilan).toLocaleString("tr-TR")}</span>
      {(s.plana_yazilan_detay || []).map((d, i) => (
        <span key={i} className="text-[10px] whitespace-nowrap bg-purple-50 text-purple-700 border border-purple-200 rounded px-1.5">{plDetayTxt(d)}</span>
      ))}
    </div>
  );
}
const esc = (v) => String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

// Üretim planlama PDF/Excel çıktıları için sıralama/gruplama
const FIRIN_SIRA = ["Servis", "Pasta", "Çukur", "Makarna", "Kase", "Plaka", "Plaka Üstü", "Pizza", "Dolgu"];
const SATIS_SIRA = ["Fason", "Horeca"];
const terminPr = (t) => {
  if (!t) return 2;
  const d = new Date(String(t).slice(0, 10) + "T00:00:00");
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const diff = Math.round((d - today) / 86400000);
  if (diff < 0) return 0;
  if (diff <= 7) return 1;
  return 2;
};
const satisOf = (r) => {
  const s = (r.satis_noktasi || "").toLowerCase();
  if (s.includes("fason")) return "Fason";
  if (s.includes("horeca")) return "Horeca";
  return r.satis_noktasi || "Diğer";
};
// Sıralı bölümler: [{label,count,rows}] — önce Fason/Horeca, sonra fırın sırası, bölüm içi termin+kalan+kalıp
function planlamaSections(data) {
  const out = [];
  const satisGroups = {};
  data.forEach((r) => { const sn = satisOf(r); (satisGroups[sn] = satisGroups[sn] || []).push(r); });
  const satisKeys = [...SATIS_SIRA.filter((s) => satisGroups[s]), ...Object.keys(satisGroups).filter((s) => !SATIS_SIRA.includes(s))];
  satisKeys.forEach((sn) => {
    const bgroups = {};
    satisGroups[sn].forEach((r) => { const b = r.bolum || "TANIMSIZ"; (bgroups[b] = bgroups[b] || []).push(r); });
    const bKeys = [...FIRIN_SIRA.filter((b) => bgroups[b]), ...Object.keys(bgroups).filter((b) => !FIRIN_SIRA.includes(b))];
    bKeys.forEach((b) => {
      const rows = bgroups[b];
      const kgroups = {};
      rows.forEach((r) => { const k = r.kalip_kodu || ""; (kgroups[k] = kgroups[k] || []).push(r); });
      const kList = Object.values(kgroups).map((g) => {
        g.sort((a, c) => ((Number(a.uretime_gore_kalan) || 0) - (Number(c.uretime_gore_kalan) || 0)) || (terminPr(a.termin_tarihi) - terminPr(c.termin_tarihi)));
        return { g, pr: Math.min(...g.map((x) => terminPr(x.termin_tarihi))), minKalan: Math.min(...g.map((x) => Number(x.uretime_gore_kalan) || 0)) };
      });
      kList.sort((a, c) => (a.minKalan - c.minKalan) || (a.pr - c.pr) || String(a.g[0].kalip_kodu || "").localeCompare(String(c.g[0].kalip_kodu || ""), "tr"));
      const orderedRows = [];
      kList.forEach(({ g }) => g.forEach((r) => orderedRows.push(r)));
      out.push({ label: `${sn} — ${b}`, count: rows.length, rows: orderedRows });
    });
  });
  return out;
}
// Excel: tek tablo, bölüm başlık satırı + aralara boş satır
function planlamaExportEntries(data) {
  const secs = planlamaSections(data);
  const entries = [];
  secs.forEach((s, i) => {
    entries.push({ kind: "section", label: s.label, count: s.count });
    s.rows.forEach((r) => entries.push({ kind: "data", row: r }));
    if (i < secs.length - 1) entries.push({ kind: "spacer" });
  });
  return entries;
}
const excelEntriesHtml = (data, cols) => {
  const n = cols.length;
  return planlamaExportEntries(data).map((e) => {
    if (e.kind === "spacer") return `<tr><td colspan="${n}" style="height:10px;border:none;"></td></tr>`;
    if (e.kind === "section") return `<tr><td colspan="${n}" style="background:#D9D9D9;color:#000;font-weight:bold;font-size:12px;padding:4px;">${esc(e.label)} (${e.count})</td></tr>`;
    const r = e.row; const th = terminHex(r.termin_tarihi);
    const st = th ? ` style="background:${th.bg};color:#000;font-weight:bold;"` : "";
    return `<tr${st}>${cols.map((c) => `<td>${esc(cellVal(r, c))}</td>`).join("")}</tr>`;
  }).join("");
};
// PDF: her bölüm ayrı tablo; thead (başlık + sütun adları) sayfa taşmalarında üstte tekrar eder
const pdfSectionsHtml = (data, cols) => {
  const n = cols.length;
  const headCells = cols.map((c) => `<th class="${c.num ? "r" : ""}">${esc(c.label)}</th>`).join("");
  return planlamaSections(data).map((s) => {
    const bodyRows = s.rows.map((r) => {
      const th = terminHex(r.termin_tarihi);
      const st = th ? ` style="background:${th.bg};color:#000;font-weight:bold;"` : "";
      return `<tr${st}>${cols.map((c) => `<td class="${c.num ? "r" : ""}">${esc(cellVal(r, c))}</td>`).join("")}</tr>`;
    }).join("");
    return `<table class="sec"><thead><tr><th colspan="${n}" class="sec-title">${esc(s.label)} (${s.count})</th></tr><tr>${headCells}</tr></thead><tbody>${bodyRows}</tbody></table>`;
  }).join("");
};

function Oneriler({ onAdded }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(true);
  const [selected, setSelected] = useState(new Set());
  const [hidden, setHidden] = useState(new Set());
  const [colMenu, setColMenu] = useState(false);
  const [flt, setFlt] = useState({});
  const [openFlt, setOpenFlt] = useState(null);

  const load = () => {
    setLoading(true);
    setSelected(new Set());
    api.get("/planlama/oneriler?limit=100000").then((r) => setRows(r.data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const cols = ONERI_COLS.filter((c) => !hidden.has(c.key));
  const match = (s) => cols.every((c) => !flt[c.key] || String(s[c.key] ?? "").toLowerCase().includes(String(flt[c.key]).toLowerCase()));
  const allSel = rows.length > 0 && selected.size === rows.length;
  const toggleAll = () => setSelected(allSel ? new Set() : new Set(rows.map((_, i) => i)));
  const toggleOne = (i) => setSelected((s) => { const n = new Set(s); n.has(i) ? n.delete(i) : n.add(i); return n; });
  const toggleCol = (k) => setHidden((h) => { const n = new Set(h); n.has(k) ? n.delete(k) : n.add(k); return n; });
  const dataFor = () => (selected.size ? rows.filter((_, i) => selected.has(i)) : rows);
  const idxOf = new Map(rows.map((r, i) => [r, i]));
  const orderedRows = planlamaSections(rows).flatMap((sec) => sec.rows);

  const exportExcel = () => {
    const data = dataFor();
    const head = cols.map((c) => `<th style="background:#18181B;color:#fff;font-weight:bold;">${esc(c.label)}</th>`).join("");
    const body = excelEntriesHtml(data, cols);
    const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body><table border="1">${EXCEL_LEGEND(cols.length)}<tr>${head}</tr>${body}</table></body></html>`;
    const blob = new Blob(["\ufeff", html], { type: "application/vnd.ms-excel" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `Öneriler - ${damga()}.xls`; a.click();
    URL.revokeObjectURL(url);
    toast.success("Excel indiriliyor");
  };

  const exportPdf = () => {
    const data = dataFor();
    const w = window.open("", "_blank");
    if (!w) { toast.error("Yazdırma penceresi açılamadı (pop-up engelli)"); return; }
    const sections = pdfSectionsHtml(data, cols);
    w.document.write(`<!DOCTYPE html><html lang="tr"><head><meta charset="utf-8"><title>Öneriler - ${damga()}</title>
      <style>@page{size:A4 landscape;margin:10mm;}*{-webkit-print-color-adjust:exact;}body{font-family:Arial;color:#111;}
      .hdr{display:flex;justify-content:space-between;align-items:center;border-bottom:2px solid #18181B;padding-bottom:6px;margin-bottom:10px;}
      .hdr img{height:38px;} h1{font-size:14px;margin:0;} .meta{font-size:10px;color:#666;text-align:right;}
      table{border-collapse:collapse;width:100%;font-size:10px;}th,td{border:1px solid #333;padding:4px 6px;text-align:left;}th{background:#E9E9E9;}.r{text-align:right;}
      table.sec{margin-bottom:10px;}thead{display:table-header-group;}tr{page-break-inside:avoid;}th.sec-title{background:#D9D9D9;color:#000;font-weight:bold;text-align:left;font-size:12px;}
      </style></head><body>
      <div class="hdr"><div style="display:flex;align-items:center;gap:10px;"><img src="${window.location.origin}/by-bone-logo.png"/><h1>Öneriler — Bisküvi stoğu olan &amp; termini en yakın siparişler</h1></div><div class="meta">BY BONE PORSELEN<br/>${new Date().toLocaleString("tr-TR")} — ${data.length} kayıt</div></div>
      ${PDF_LEGEND}
      ${sections}</body></html>`);
    w.document.close(); w.focus();
    setTimeout(() => w.print(), 300);
  };

  const [ekleForm, setEkleForm] = useState(null);
  const kaydet = async () => {
    const f = ekleForm; if (!f) return;
    const adet = Number(f.adet);
    if (!f.tarih) { toast.error("Tarih seçin"); return; }
    if (isNaN(adet) || adet <= 0) { toast.error("Geçerli adet girin"); return; }
    try {
      await api.post("/entity/planlama", {
        tarih: f.tarih, vardiya: f.vardiya || "", urun_kodu_tam: f.row.urun_kodu, bolum: f.row.bolum || "",
        urun_kodu: f.row.kalip_kodu, aciklama: f.row.renk || "", adet, notu: "ÖNERİ", logo: "",
      });
      toast.success(`Plana eklendi (${trTarih(f.tarih)}${f.vardiya ? " · " + f.vardiya : ""})`);
      setEkleForm(null);
      onAdded && onAdded();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  const fmtNum = (n) => (n == null || n === "" ? "" : Number(n).toLocaleString("tr-TR"));

  return (
    <div className="border border-amber-300 bg-amber-50/50 rounded-sm mb-5" data-testid="oneriler-panel">
      <button onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between px-4 py-3">
        <span className="flex items-center gap-2 font-head font-bold text-sm uppercase tracking-wide text-amber-800">
          <Lightbulb size={16} /> Öneriler — Bisküvi stoğu olan & termini en yakın siparişler ({rows.length})
        </span>
        {open ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
      </button>
      {open && (
        <div className="px-4 pb-4">
          <div className="flex items-center justify-end gap-2 mb-2">
            <div className="relative">
              <button onClick={() => setColMenu((v) => !v)} data-testid="oneri-columns-btn"
                className="flex items-center gap-1.5 border border-zinc-300 bg-white hover:bg-zinc-50 text-zinc-700 text-xs font-semibold px-2.5 py-1.5 rounded-sm">
                <Columns3 size={14} /> Sütunlar
              </button>
              {colMenu && (
                <div className="absolute right-0 z-20 mt-1 w-56 bg-white border border-zinc-200 rounded-sm shadow-lg p-2" data-testid="oneri-columns-menu">
                  {ONERI_COLS.map((c) => (
                    <label key={c.key} className="flex items-center gap-2 px-2 py-1 text-sm text-zinc-700 hover:bg-zinc-50 rounded-sm cursor-pointer">
                      <input type="checkbox" checked={!hidden.has(c.key)} onChange={() => toggleCol(c.key)} className="accent-amber-600" />
                      {c.label}
                    </label>
                  ))}
                </div>
              )}
            </div>
            <button onClick={exportPdf} data-testid="oneri-pdf-btn"
              className="flex items-center gap-1.5 border border-zinc-300 bg-white hover:bg-zinc-50 text-zinc-700 text-xs font-semibold px-2.5 py-1.5 rounded-sm">
              <Printer size={14} /> PDF
            </button>
            <button onClick={exportExcel} data-testid="oneri-excel-btn"
              className="flex items-center gap-1.5 bg-green-700 hover:bg-green-800 text-white text-xs font-semibold px-2.5 py-1.5 rounded-sm">
              <Download size={14} /> Excel'e Aktar
            </button>
          </div>

          {selected.size > 0 && (
            <div className="flex items-center gap-3 mb-2 bg-amber-100 border border-amber-300 rounded-sm px-3 py-1.5" data-testid="oneri-bulk-bar">
              <span className="text-xs font-semibold text-amber-800">{selected.size} kayıt seçildi</span>
              <span className="text-[11px] text-amber-700">Önerilen Toplam: {fmtNum(dataFor().reduce((a, r) => a + (Number(r.onerilen_adet) || 0), 0))}</span>
              <button onClick={() => setSelected(new Set())} className="text-[11px] text-zinc-500 underline ml-auto" data-testid="oneri-clear-selection">Seçimi kaldır</button>
            </div>
          )}

          <div className="border border-zinc-200 bg-white rounded-sm overflow-x-auto max-h-96 overflow-y-auto">
            <table className="w-full data-table" data-testid="oneriler-table">
              <thead>
                <tr>
                  <th className="w-8">
                    <input type="checkbox" checked={allSel} onChange={toggleAll} data-testid="oneri-select-all" className="accent-amber-600" />
                  </th>
                  {cols.map((c) => (
                    <th key={c.key} className={`relative ${c.num ? "text-right" : ""}`}>
                      <div className={`flex items-center gap-1 ${c.num ? "justify-end" : ""}`}>
                        <span>{c.label}</span>
                        <button onClick={() => setOpenFlt(openFlt === c.key ? null : c.key)} data-testid={`oneri-filter-btn-${c.key}`} className={flt[c.key] ? "text-amber-600" : "text-zinc-400 hover:text-amber-600"}><Filter size={12} /></button>
                      </div>
                      {openFlt === c.key && (
                        <div className="absolute z-30 mt-1 left-0 bg-white border border-zinc-200 rounded shadow-lg p-2 flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
                          <input autoFocus value={flt[c.key] || ""} onChange={(e) => setFlt((f) => ({ ...f, [c.key]: e.target.value }))} placeholder="Filtre..." data-testid={`oneri-filter-${c.key}`} className="border border-zinc-300 rounded px-2 py-1 text-xs font-normal normal-case w-36" />
                          {flt[c.key] && <button onClick={() => setFlt((f) => ({ ...f, [c.key]: "" }))} className="text-xs text-zinc-500 underline">Temizle</button>}
                        </div>
                      )}
                    </th>
                  ))}
                  <th className="text-right">İşlem</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={cols.length + 2} className="text-center py-8 text-zinc-400"><Loader2 className="animate-spin inline" size={16} /> Yükleniyor...</td></tr>
                ) : rows.length === 0 ? (
                  <tr><td colSpan={cols.length + 2} className="text-center py-8 text-zinc-400">Uygun öneri yok (bisküvi stoğu olan bekleyen sipariş bulunamadı).</td></tr>
                ) : orderedRows.map((s) => { const i = idxOf.get(s); return !match(s) ? null : (
                  <tr key={i} data-testid={`oneri-row-${i}`} className={`border-l-4 border-green-500 ${selected.has(i) ? "bg-amber-50" : ""}`}>
                    <td className="w-8">
                      <input type="checkbox" checked={selected.has(i)} onChange={() => toggleOne(i)} data-testid={`oneri-select-${i}`} className="accent-amber-600" />
                    </td>
                    {cols.map((c) => (
                      <td key={c.key} className={c.cls || ""}>
                        {c.render ? c.render(s) : (c.num ? fmtNum(s[c.key]) : (s[c.key] || "—"))}
                      </td>
                    ))}
                    <td className="text-right">
                      <button onClick={() => setEkleForm({ row: s, tarih: today(), vardiya: VARDIYA[1], adet: s.onerilen_adet })} data-testid={`oneri-ekle-${i}`}
                        className="inline-flex items-center gap-1 bg-amber-600 hover:bg-amber-700 text-white text-xs font-semibold px-2.5 py-1.5 rounded-sm">
                        <Plus size={13} /> Plana Ekle
                      </button>
                    </td>
                  </tr>
                ); })}
              </tbody>
            </table>
          </div>
          {ekleForm && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onMouseDown={() => setEkleForm(null)}>
              <div className="bg-white rounded-md shadow-2xl w-full max-w-sm" onMouseDown={(e) => e.stopPropagation()} data-testid="oneri-ekle-modal">
                <div className="px-4 py-3 bg-zinc-800 text-white rounded-t-md font-head font-bold text-sm">Plana Ekle — {ekleForm.row.urun_kodu}</div>
                <div className="p-4 space-y-3">
                  <div>
                    <label className="block text-xs font-semibold text-zinc-600 mb-1">Tarih</label>
                    <input type="date" value={ekleForm.tarih} onChange={(e) => setEkleForm((f) => ({ ...f, tarih: e.target.value }))} data-testid="oneri-ekle-tarih" className="w-full border border-zinc-300 rounded-sm px-3 py-2 text-sm" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-zinc-600 mb-1">Vardiya</label>
                    <select value={ekleForm.vardiya} onChange={(e) => setEkleForm((f) => ({ ...f, vardiya: e.target.value }))} data-testid="oneri-ekle-vardiya" className="w-full border border-zinc-300 rounded-sm px-3 py-2 text-sm">
                      {VARDIYA.map((v) => <option key={v} value={v}>{v}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-zinc-600 mb-1">Adet</label>
                    <input type="number" value={ekleForm.adet} onChange={(e) => setEkleForm((f) => ({ ...f, adet: e.target.value }))} data-testid="oneri-ekle-adet" className="w-full border border-zinc-300 rounded-sm px-3 py-2 text-sm" />
                  </div>
                </div>
                <div className="px-4 py-3 border-t flex justify-end gap-2">
                  <button onClick={() => setEkleForm(null)} className="text-sm text-zinc-600 px-3 py-1.5">İptal</button>
                  <button onClick={kaydet} data-testid="oneri-ekle-kaydet" className="bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold px-4 py-1.5 rounded-sm">Plana Ekle</button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const ONERI2_COLS = [
  { key: "termin_tarihi", label: "Termin", cls: "mono", render: (s) => <TerminCell t={s.termin_tarihi} /> },
  { key: "musteri", label: "Müşteri", cls: "max-w-[280px]",
    render: (s) => (
      <div>
        <div className="whitespace-normal text-xs">{s.musteri || "—"}</div>
        {Number(s.musteri_sayisi) > 1 && <span className="text-[10px] text-purple-700 font-bold">{s.musteri_sayisi} müşteri</span>}
      </div>
    ) },
  { key: "urun_kodu", label: "Ürün Kodu", cls: "mono max-w-[220px] whitespace-normal text-xs", render: (s) => { const c = terminCls(s.termin_tarihi); return <span className={c ? `mono inline-block rounded px-2 py-0.5 text-xs font-bold ${c}` : "mono text-xs"}>{s.urun_kodu}</span>; } },
  { key: "kalip_kodu", label: "Kalıp", cls: "mono" },
  { key: "renk", label: "Renk" },
  { key: "bolum", label: "Bölüm" },
  { key: "kalan", label: "Kaliteye Göre Kalan", num: true, cls: "num font-semibold" },
  { key: "uretime_gore_kalan", label: "Üretime Göre Kalan", num: true, cls: "num text-red-600 font-semibold" },
  { key: "uretime_yapilan", label: "Üretime Göre Yapılan", num: true, cls: "num text-blue-700 font-semibold" },
  { key: "kalite_yapilan", label: "Kaliteye Göre Yapılan", num: true, cls: "num text-emerald-700 font-semibold" },
  { key: "kaliteden_gecmemis", label: "Kaliteden Geçmemiş Ürün", num: true, cls: "num text-orange-600 font-semibold" },
  { key: "kaliteden_gecmeyen", label: "Kaliteden Geçmemiş Ürün Üretim Girişi", num: true, cls: "num text-rose-600 font-semibold" },
  { key: "biskuvi_stok", label: "Bisküvi Stok", num: true, cls: "num text-sky-700 font-semibold" },
  { key: "onerilen_adet", label: "Önerilen", num: true, cls: "num text-green-700 font-bold" },
  { key: "plana_yazilan", label: "Plana Yazılan", num: true, cls: "num",
    render: (s) => <PlanaYazilanCell s={s} /> },
];

function Oneriler2({ onAdded }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [flt, setFlt] = useState({});
  const [openFlt, setOpenFlt] = useState(null);
  const [ekleForm, setEkleForm] = useState(null);

  const load = () => {
    setLoading(true);
    api.get("/planlama/oneriler2?limit=100000").then((r) => setRows(r.data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const match = (s) => ONERI2_COLS.every((c) => !flt[c.key] || String(s[c.key] ?? "").toLowerCase().includes(String(flt[c.key]).toLowerCase()));
  const filtered = planlamaSections(rows.filter(match)).flatMap((sec) => sec.rows);
  const fmtNum = (n) => (n == null || n === "" ? "" : Number(n).toLocaleString("tr-TR"));

  const exportExcel = () => {
    const head = ONERI2_COLS.map((c) => `<th style="background:#18181B;color:#fff;font-weight:bold;">${esc(c.label)}</th>`).join("");
    const body = excelEntriesHtml(filtered, ONERI2_COLS);
    const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body><table border="1">${EXCEL_LEGEND(ONERI2_COLS.length)}<tr>${head}</tr>${body}</table></body></html>`;
    const blob = new Blob(["\ufeff", html], { type: "application/vnd.ms-excel" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `Öneri 2 (Ürün Bazında) - ${damga()}.xls`; a.click();
    URL.revokeObjectURL(url);
  };
  const exportPdf = () => {
    const w = window.open("", "_blank"); if (!w) { toast.error("Yazdırma penceresi açılamadı"); return; }
    const sections = pdfSectionsHtml(filtered, ONERI2_COLS);
    w.document.write(`<!DOCTYPE html><html lang="tr"><head><meta charset="utf-8"><title>Öneri 2 - ${damga()}</title>
      <style>@page{size:A4 landscape;margin:10mm;}*{-webkit-print-color-adjust:exact;}body{font-family:Arial;color:#111;}
      .hdr{display:flex;justify-content:space-between;align-items:center;border-bottom:2px solid #18181B;padding-bottom:6px;margin-bottom:10px;}.hdr img{height:38px;}h1{font-size:14px;margin:0;}.meta{font-size:10px;color:#666;text-align:right;}
      table{border-collapse:collapse;width:100%;font-size:9px;}th,td{border:1px solid #333;padding:3px 5px;text-align:left;}th{background:#E9E9E9;}.r{text-align:right;}table.sec{margin-bottom:10px;}thead{display:table-header-group;}tr{page-break-inside:avoid;}th.sec-title{background:#D9D9D9;color:#000;font-weight:bold;text-align:left;font-size:11px;}</style></head><body>
      <div class="hdr"><div style="display:flex;align-items:center;gap:10px;"><img src="${window.location.origin}/by-bone-logo.png"/><h1>Öneri 2 — Ürün bazında (müşteriler birleşik, termine göre)</h1></div><div class="meta">BY BONE PORSELEN<br/>${new Date().toLocaleString("tr-TR")} — ${filtered.length} ürün</div></div>
      ${PDF_LEGEND}
      ${sections}</body></html>`);
    w.document.close(); w.focus(); setTimeout(() => w.print(), 300);
  };

  const kaydet = async () => {
    const f = ekleForm; if (!f) return;
    const adet = Number(f.adet);
    if (!f.tarih) { toast.error("Tarih seçin"); return; }
    if (isNaN(adet) || adet <= 0) { toast.error("Geçerli adet girin"); return; }
    try {
      await api.post("/entity/planlama", {
        tarih: f.tarih, vardiya: f.vardiya || "", urun_kodu_tam: f.row.urun_kodu_ilk || f.row.kalip_kodu, bolum: f.row.bolum || "",
        urun_kodu: f.row.kalip_kodu, aciklama: f.row.renk || "", adet, notu: "ÖNERİ 2", logo: "",
      });
      toast.success(`Plana eklendi (${trTarih(f.tarih)}${f.vardiya ? " · " + f.vardiya : ""})`);
      setEkleForm(null); onAdded && onAdded(); load();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div className="border border-indigo-300 bg-indigo-50/40 rounded-sm mb-5" data-testid="oneriler2-panel">
      <button onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between px-4 py-3">
        <span className="flex items-center gap-2 font-head font-bold text-sm uppercase tracking-wide text-indigo-800">
          <Lightbulb size={16} /> Öneri 2 — Ürün bazında (müşteriler tek satırda, termine göre) ({rows.length})
        </span>
        {open ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
      </button>
      {open && (
        <div className="px-4 pb-4">
          <div className="flex items-center justify-end gap-2 mb-2">
            <button onClick={exportPdf} data-testid="oneri2-pdf-btn" className="flex items-center gap-1.5 border border-zinc-300 bg-white hover:bg-zinc-50 text-zinc-700 text-xs font-semibold px-2.5 py-1.5 rounded-sm"><Printer size={14} /> PDF</button>
            <button onClick={exportExcel} data-testid="oneri2-excel-btn" className="flex items-center gap-1.5 bg-green-700 hover:bg-green-800 text-white text-xs font-semibold px-2.5 py-1.5 rounded-sm"><Download size={14} /> Excel'e Aktar</button>
          </div>
          <div className="border border-zinc-200 bg-white rounded-sm overflow-x-auto max-h-96 overflow-y-auto">
            <table className="w-full data-table" data-testid="oneriler2-table">
              <thead>
                <tr>
                  {ONERI2_COLS.map((c) => (
                    <th key={c.key} className={`relative ${c.num ? "text-right" : ""}`}>
                      <div className={`flex items-center gap-1 ${c.num ? "justify-end" : ""}`}>
                        <span>{c.label}</span>
                        <button onClick={() => setOpenFlt(openFlt === c.key ? null : c.key)} data-testid={`oneri2-filter-btn-${c.key}`} className={flt[c.key] ? "text-indigo-600" : "text-zinc-400 hover:text-indigo-600"}><Filter size={12} /></button>
                      </div>
                      {openFlt === c.key && (
                        <div className="absolute z-30 mt-1 left-0 bg-white border border-zinc-200 rounded shadow-lg p-2 flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
                          <input autoFocus value={flt[c.key] || ""} onChange={(e) => setFlt((f) => ({ ...f, [c.key]: e.target.value }))} placeholder="Filtre..." data-testid={`oneri2-filter-${c.key}`} className="border border-zinc-300 rounded px-2 py-1 text-xs font-normal normal-case w-36" />
                          {flt[c.key] && <button onClick={() => setFlt((f) => ({ ...f, [c.key]: "" }))} className="text-xs text-zinc-500 underline">Temizle</button>}
                        </div>
                      )}
                    </th>
                  ))}
                  <th className="text-right">İşlem</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={ONERI2_COLS.length + 1} className="text-center py-8 text-zinc-400"><Loader2 className="animate-spin inline" size={16} /> Yükleniyor...</td></tr>
                ) : filtered.length === 0 ? (
                  <tr><td colSpan={ONERI2_COLS.length + 1} className="text-center py-8 text-zinc-400">Uygun öneri yok.</td></tr>
                ) : filtered.map((s, i) => (
                  <tr key={i} data-testid={`oneri2-row-${i}`} className="border-l-4 border-indigo-500">
                    {ONERI2_COLS.map((c) => (
                      <td key={c.key} className={c.cls || ""}>
                        {c.render ? c.render(s) : (c.num ? fmtNum(s[c.key]) : (s[c.key] || "—"))}
                      </td>
                    ))}
                    <td className="text-right">
                      <button onClick={() => setEkleForm({ row: s, tarih: today(), vardiya: VARDIYA[1], adet: s.onerilen_adet })} data-testid={`oneri2-ekle-${i}`}
                        className="inline-flex items-center gap-1 bg-indigo-600 hover:bg-indigo-700 text-white text-xs font-semibold px-2.5 py-1.5 rounded-sm">
                        <Plus size={13} /> Plana Ekle
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {ekleForm && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onMouseDown={() => setEkleForm(null)}>
              <div className="bg-white rounded-md shadow-2xl w-full max-w-sm" onMouseDown={(e) => e.stopPropagation()} data-testid="oneri2-ekle-modal">
                <div className="px-4 py-3 bg-zinc-800 text-white rounded-t-md font-head font-bold text-sm">Plana Ekle — {ekleForm.row.urun_kodu}</div>
                <div className="p-4 space-y-3">
                  <div>
                    <label className="block text-xs font-semibold text-zinc-600 mb-1">Tarih</label>
                    <input type="date" value={ekleForm.tarih} onChange={(e) => setEkleForm((f) => ({ ...f, tarih: e.target.value }))} data-testid="oneri2-ekle-tarih" className="w-full border border-zinc-300 rounded-sm px-3 py-2 text-sm" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-zinc-600 mb-1">Vardiya</label>
                    <select value={ekleForm.vardiya} onChange={(e) => setEkleForm((f) => ({ ...f, vardiya: e.target.value }))} data-testid="oneri2-ekle-vardiya" className="w-full border border-zinc-300 rounded-sm px-3 py-2 text-sm">
                      {VARDIYA.map((v) => <option key={v} value={v}>{v}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-zinc-600 mb-1">Adet</label>
                    <input type="number" value={ekleForm.adet} onChange={(e) => setEkleForm((f) => ({ ...f, adet: e.target.value }))} data-testid="oneri2-ekle-adet" className="w-full border border-zinc-300 rounded-sm px-3 py-2 text-sm" />
                  </div>
                </div>
                <div className="px-4 py-3 border-t flex justify-end gap-2">
                  <button onClick={() => setEkleForm(null)} className="text-sm text-zinc-600 px-3 py-1.5">İptal</button>
                  <button onClick={kaydet} data-testid="oneri2-ekle-kaydet" className="bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold px-4 py-1.5 rounded-sm">Plana Ekle</button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}


const DURUM_CFG = {
  "Yapıldı": "bg-green-100 text-green-700",
  "Kısmi": "bg-amber-100 text-amber-700",
  "Yapılmadı": "bg-red-100 text-red-700",
};

function PlanDurum({ onChange }) {
  const { user } = useAuth();
  const canEdit = user?.role !== "viewer";
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(true);
  const [sel, setSel] = useState(new Set());
  const [pf, setPf] = useState({});
  const [openPf, setOpenPf] = useState(null);
  const load = () => api.get("/dashboard/plan-durum").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const groups = {};
  rows.forEach((r) => { const k = trTarih(r.tarih); (groups[k] = groups[k] || []).push(r); });
  const keys = Object.keys(groups)
    .sort((a, b) => a.split(".").reverse().join("").localeCompare(b.split(".").reverse().join("")));
  const listedRows = keys.flatMap((k) => groups[k]);
  const PF_KEYS = ["urun_kodu", "kalip", "aciklama", "bolum", "vardiya", "durum"];
  const pmatch = (r) => PF_KEYS.every((k) => !pf[k] || String(r[k] ?? "").toLowerCase().includes(String(pf[k]).toLowerCase()));
  const PLAN_COLS = [
    { key: "urun_kodu", label: "Ürün Kodu" },
    { key: "kalip", label: "Kalıp" },
    { key: "aciklama", label: "Açıklama" },
    { key: "bolum", label: "Bölüm" },
    { key: "vardiya", label: "Vardiya" },
    { key: "planlanan", label: "Planlanan", num: true, noFilter: true },
    { key: "yapilan", label: "Yapılan", num: true, noFilter: true },
    { key: "eksik", label: "Eksik", num: true, noFilter: true },
    { key: "durum", label: "Durum" },
  ];
  const rowKey = (r) => `${r.tarih}|${r.urun_kodu}`;
  const toggle = (r) => setSel((s) => { const n = new Set(s); const k = rowKey(r); n.has(k) ? n.delete(k) : n.add(k); return n; });

  const doReload = () => { load(); onChange && onChange(); };
  const silOne = async (r) => {
    if (!window.confirm(`${r.urun_kodu} (${trTarih(r.tarih)}) plandan silinsin mi?`)) return;
    try { await api.post("/planlama/gun-sil", { tarih: r.tarih, urun_kodu_tam: r.urun_kodu }); toast.success("Plandan silindi"); doReload(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const bulkSil = async () => {
    const items = listedRows.filter((r) => sel.has(rowKey(r)));
    if (!items.length || !window.confirm(`${items.length} kalem silinsin mi?`)) return;
    try { for (const r of items) await api.post("/planlama/gun-sil", { tarih: r.tarih, urun_kodu_tam: r.urun_kodu }); toast.success(`${items.length} kalem silindi`); setSel(new Set()); doReload(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const duzelt = async (r) => {
    const v = window.prompt(`${r.urun_kodu} — yeni planlanan adet:`, r.planlanan);
    if (v === null) return;
    const adet = Number(v);
    if (isNaN(adet) || adet < 0) { toast.error("Geçersiz adet"); return; }
    try { await api.post("/planlama/gun-guncelle", { tarih: r.tarih, urun_kodu_tam: r.urun_kodu, adet }); toast.success("Güncellendi"); doReload(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  const EXP = [["tarih", "Tarih"], ["urun_kodu", "Ürün Kodu"], ["kalip", "Kalıp"], ["aciklama", "Açıklama"], ["bolum", "Bölüm"], ["vardiya", "Vardiya"], ["planlanan", "Planlanan"], ["yapilan", "Yapılan"], ["eksik", "Eksik"], ["durum", "Durum"]];
  const expData = () => (sel.size ? listedRows.filter((r) => sel.has(rowKey(r))) : listedRows);
  const cell = (k, r) => (k === "tarih" ? trTarih(r[k]) : r[k]);
  const excel = () => {
    const data = expData();
    const head = EXP.map(([, l]) => `<th style="background:#18181B;color:#fff;font-weight:bold;">${esc(l)}</th>`).join("");
    const body = data.map((r) => `<tr>${EXP.map(([k]) => `<td>${esc(cell(k, r))}</td>`).join("")}</tr>`).join("");
    const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office"><head><meta charset="utf-8"></head><body><table border="1"><tr>${head}</tr>${body}</table></body></html>`;
    const b = new Blob(["\ufeff", html], { type: "application/vnd.ms-excel" }); const u = URL.createObjectURL(b);
    const a = document.createElement("a"); a.href = u; a.download = `Plan Durumu - ${damga()}.xls`; a.click(); URL.revokeObjectURL(u); toast.success("Excel indiriliyor");
  };
  const pdf = () => {
    const data = expData(); const w = window.open("", "_blank"); if (!w) { toast.error("Yazdırma penceresi açılamadı (pop-up engelli)"); return; }
    const head = EXP.map(([, l]) => `<th>${esc(l)}</th>`).join("");
    const body = data.map((r) => `<tr>${EXP.map(([k]) => `<td>${esc(cell(k, r))}</td>`).join("")}</tr>`).join("");
    w.document.write(`<!DOCTYPE html><html lang="tr"><head><meta charset="utf-8"><title>Plan Durumu - ${damga()}</title><style>@page{size:A4 landscape;margin:10mm}*{-webkit-print-color-adjust:exact}body{font-family:Arial;color:#111}.hdr{display:flex;align-items:center;gap:10px;border-bottom:2px solid #18181B;padding-bottom:6px;margin-bottom:8px}.hdr img{height:36px}h1{font-size:14px;margin:0}table{border-collapse:collapse;width:100%;font-size:10px}th,td{border:1px solid #333;padding:4px 6px;text-align:left}th{background:#E9E9E9}</style></head><body><div class="hdr"><img src="${window.location.origin}/by-bone-logo.png"/><h1>Üretim Plan Durumu — Gün Bazında</h1></div><div style="font-size:10px;color:#666;margin-bottom:8px">${new Date().toLocaleString("tr-TR")} — ${data.length} kayıt</div><table><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table></body></html>`);
    w.document.close(); w.focus(); setTimeout(() => w.print(), 300);
  };

  return (
    <div className="border border-zinc-300 bg-white rounded-sm mb-5" data-testid="plan-durum-section">
      <button onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between px-4 py-3">
        <span className="flex items-center gap-2 font-head font-bold text-sm uppercase tracking-wide text-zinc-800">
          <ClipboardCheck size={16} /> Üretim Plan Durumu — Gün Bazında (Yapılan + Yapılmayan · 3 vardiya)
        </span>
        {open ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
      </button>
      {open && (
        <div className="px-4 pb-4">
          <div className="flex items-center justify-end gap-2 mb-2">
            <button onClick={pdf} data-testid="plan-durum-pdf-btn" className="flex items-center gap-1.5 border border-zinc-300 bg-white hover:bg-zinc-50 text-zinc-700 text-xs font-semibold px-2.5 py-1.5 rounded-sm"><Printer size={14} /> PDF</button>
            <button onClick={excel} data-testid="plan-durum-excel-btn" className="flex items-center gap-1.5 bg-green-700 hover:bg-green-800 text-white text-xs font-semibold px-2.5 py-1.5 rounded-sm"><Download size={14} /> Excel'e Aktar</button>
          </div>
          {canEdit && sel.size > 0 && (
            <div className="flex items-center gap-3 mb-2 bg-red-50 border border-red-200 rounded-sm px-3 py-1.5" data-testid="plan-durum-bulk-bar">
              <span className="text-xs font-semibold text-red-700">{sel.size} kalem seçildi</span>
              <button onClick={bulkSil} data-testid="plan-durum-bulk-sil" className="flex items-center gap-1 bg-red-600 hover:bg-red-700 text-white text-xs font-semibold px-2.5 py-1 rounded-sm"><Trash2 size={13} /> Seçilenleri Sil</button>
              <button onClick={() => setSel(new Set())} className="text-[11px] text-zinc-500 underline ml-auto">Seçimi kaldır</button>
            </div>
          )}
          {keys.length === 0 ? (
            <div className="text-green-600 py-6 text-center text-sm font-semibold">Tüm plan kalemleri yapıldı — bekleyen yok.</div>
          ) : keys.map((k) => {
            const all = groups[k];
            const eksikList = all.filter((r) => r.durum !== "Yapıldı");
            const list = all.filter(pmatch);
            const plan = all.reduce((s, r) => s + r.planlanan, 0);
            const yap = all.reduce((s, r) => s + r.yapilan, 0);
            const eksikTop = eksikList.reduce((s, r) => s + (r.eksik || 0), 0);
            return (
              <div key={k} className="mb-4 border border-zinc-200 rounded-sm overflow-hidden" data-testid="plan-grup">
                <div className="flex items-center justify-between px-3 py-2 bg-zinc-800 text-white text-sm font-semibold">
                  <span>{k}</span>
                  <span className="text-xs">Plan: {plan.toLocaleString("tr-TR")} · Yapılan: {yap.toLocaleString("tr-TR")} · <span className="text-red-300">Eksik kalem: {eksikList.length} ({eksikTop.toLocaleString("tr-TR")} adet)</span></span>
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full data-table">
                    <thead><tr>{canEdit && <th className="w-8"></th>}
                      {PLAN_COLS.map((c) => (
                        <th key={c.key} className={`relative ${c.num ? "text-right" : ""}`}>
                          <div className={`flex items-center gap-1 ${c.num ? "justify-end" : ""}`}>
                            <span>{c.label}</span>
                            {!c.noFilter && (
                              <button onClick={() => setOpenPf(openPf === c.key ? null : c.key)} data-testid={`plan-filter-btn-${c.key}`} className={pf[c.key] ? "text-amber-600" : "text-zinc-400 hover:text-amber-600"}><Filter size={12} /></button>
                            )}
                          </div>
                          {openPf === c.key && (
                            <div className="absolute z-30 mt-1 left-0 bg-white border border-zinc-200 rounded shadow-lg p-2 flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
                              <input autoFocus value={pf[c.key] || ""} onChange={(e) => setPf((f) => ({ ...f, [c.key]: e.target.value }))} placeholder="Filtre..." data-testid={`plan-filter-${c.key}`} className="border border-zinc-300 rounded px-2 py-1 text-xs font-normal normal-case w-36" />
                              {pf[c.key] && <button onClick={() => setPf((f) => ({ ...f, [c.key]: "" }))} className="text-xs text-zinc-500 underline">Temizle</button>}
                            </div>
                          )}
                        </th>
                      ))}
                      {canEdit && <th className="text-right">İşlem</th>}</tr></thead>
                    <tbody>
                      {list.map((r, i) => (
                        <tr key={i} className={r.durum === "Yapılmadı" ? "bg-red-50" : "bg-amber-50"}>
                          {canEdit && <td className="w-8"><input type="checkbox" checked={sel.has(rowKey(r))} onChange={() => toggle(r)} data-testid={`plan-durum-select-${r.urun_kodu}`} className="accent-amber-600" /></td>}
                          <td className="mono">{r.urun_kodu}</td>
                          <td className="mono">{r.kalip}</td>
                          <td>{r.aciklama || "—"}</td>
                          <td>{r.bolum || "—"}</td>
                          <td className="text-xs">{r.vardiya || "—"}</td>
                          <td className="num">{r.planlanan.toLocaleString("tr-TR")}</td>
                          <td className="num font-semibold">{r.yapilan.toLocaleString("tr-TR")}</td>
                          <td className="num text-red-600 font-bold">{(r.eksik || 0).toLocaleString("tr-TR")}</td>
                          <td><span className={`px-2 py-0.5 rounded-sm text-xs font-semibold ${DURUM_CFG[r.durum]}`}>{r.durum}</span></td>
                          {canEdit && (
                            <td className="text-right whitespace-nowrap">
                              <button onClick={() => duzelt(r)} data-testid={`plan-durum-duzelt-${r.urun_kodu}`} className="p-1.5 text-zinc-500 hover:text-amber-600 hover:bg-amber-50 rounded-sm"><Pencil size={14} /></button>
                              <button onClick={() => silOne(r)} data-testid={`plan-durum-sil-${r.urun_kodu}`} className="p-1.5 text-zinc-500 hover:text-red-600 hover:bg-red-50 rounded-sm"><Trash2 size={14} /></button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function Planlama() {
  const [syncKey, setSyncKey] = useState(0);
  const bump = () => setSyncKey((k) => k + 1);
  const columns = [
    { key: "tarih", label: "Tarih" },
    { key: "vardiya", label: "Vardiya" },
    { key: "urun_kodu_tam", label: "Ürün Kodu (Tam)", mono: true },
    { key: "bolum", label: "Bölüm" },
    { key: "urun_kodu", label: "Ürün Kodu", mono: true },
    { key: "aciklama", label: "Açıklama" },
    { key: "adet", label: "Adet", num: true },
    { key: "notu", label: "Not" },
    { key: "logo", label: "Logo" },
  ];
  const fields = [
    { key: "tarih", label: "Tarih", type: "date", required: true },
    { key: "vardiya", label: "Vardiya", type: "select", options: VARDIYA, required: true },
    { key: "urun_kodu_tam", label: "Ürün Kodu (Tam)", type: "product", required: true, span: 2,
      fills: { kalip_kodu: "urun_kodu", renk: "aciklama", firin_bolgesi: "bolum" } },
    { key: "bolum", label: "Bölüm", type: "select", options: BOLUMLER },
    { key: "urun_kodu", label: "Ürün Kodu (otomatik)", type: "text", readOnly: true, mono: true },
    { key: "aciklama", label: "Açıklama (otomatik)", type: "text", span: 2 },
    { key: "adet", label: "Adet", type: "number", required: true },
    { key: "notu", label: "Not", type: "text" },
    { key: "logo", label: "Logo", type: "text" },
  ];
  return (
    <>
      <PageHeader title="Üretim Planlama" subtitle="Vardiya bazlı üretim planı — Adet toplamı GENEL TOPLAM olarak altta görünür"
        actions={
          <button onClick={printSignedPlan} data-testid="signed-pdf-btn"
            className="flex items-center gap-2 bg-zinc-800 hover:bg-zinc-900 text-white text-sm font-semibold px-3 py-2 rounded-sm">
            <FileSignature size={15} /> Günlük İmza PDF
          </button>
        } />
      <div className="px-6 pt-6">
        <Oneriler key={`o${syncKey}`} onAdded={bump} />
        <Oneriler2 key={`o2${syncKey}`} onAdded={bump} />
      </div>
      <CrudTable key={`c${syncKey}`} endpoint="/entity/planlama" columns={columns} fields={fields} titleSingular="Plan Satırı"
        printTitle="Üretim Planlama" dateField="tarih" vardiyaFilter exportKind="planlama" onMutate={bump} />
      <div className="px-6 pb-6">
        <PlanDurum key={`d${syncKey}`} onChange={bump} />
      </div>
    </>
  );
}
